import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';

@Component({
    selector: 'app-settings',
    imports: [
        RouterOutlet,
        RouterLinkActive,
        RouterLink,
        NavbarComponent
    ],
    templateUrl: './settings.component.html',
    styleUrl: './settings.component.less'
})
export class SettingsComponent {
}
